export enum EstadosPropuesta {
    DefinicionRequisitos = '1',
    PendienteEstimacion = '2',
    EstimadaNoValorada = '4',
    Enviada = '5',
    EnNegociacion = '6',    
    Perdida = '7',    
    Ganada = '8',
    Descartada = '9',
    PendienteFormalizar = '10'
}


export enum EstadosPropuestaNombre {
    DefinicionRequisitos = 'Definición requisitos',
    PendienteEstimacion = 'Pendiente estimación',
    EstimadaNoValorada = 'Estimada no valorada',
    Enviada = 'Enviada',
    EnNegociacion = 'En negociación',    
    Perdida = 'Perdida',    
    Ganada = 'Ganada',
    Descartada = 'Descartada',
    PendienteFormalizar = 'PendienteFormalizar'        
}



